import axios from 'axios'

export default {
    namespaced: true,
    state: {
        objectSettings: [],
    },
    mutations: {
        SET_OBJECT_SETTINGS(state, payload) {
            state.objectSettings = payload;
        },
    },
    actions: {
        FetchObjectSettings({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/object-settings/list`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_OBJECT_SETTINGS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchObjectSettings: ${error.message}`));
            });
        },
        FetchObjectSettingsByObjectTypeID({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/object-settings/fetch/by/type/id`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_OBJECT_SETTINGS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchObjectSettingsByObjectTypeID: ${error.message}`));
            });
        },
    },
    getters: {
        ObjectSettings(state) { return state.objectSettings; },
    }
}
